import { createSelector } from 'reselect';

// Selectors
import { getPromotionServices } from 'store/reducers/appointment/selectors';

// Utils
import { applyPromotionToService } from 'utils/promotions';

export const getDeclinedServices = ({ declined }) => declined || [];

export const getDeclinedServicesPromotion = createSelector(
  getDeclinedServices,
  getPromotionServices,
  (declinedServices, promotionServices) => {
    if (promotionServices) {
      return applyPromotionToService(promotionServices, declinedServices);
    } else {
      return declinedServices;
    }
  }
);

export const getDeclinedServicesIds = createSelector(
  getDeclinedServices,
  declinedServices => declinedServices.map(service => service.id)
);

export const getOperationItemId = id =>
  createSelector(getDeclinedServices, declinedServices => {
    if (declinedServices.length) {
      return declinedServices.find(
        declinedService =>
          declinedService.operationItemId && declinedService.id === id
      ).operationItemId;
    }
    return null;
  });



// WEBPACK FOOTER //
// ./src/store/reducers/declined/selectors.js